import Handsontable from "handsontable";
import Choices from "choices.js";

class MultiSelectEditor extends Handsontable.editors.TextEditor {
  init() {
    super.init();
  }
    
    prepare(row, col, prop, td, originalValue, cellProperties) {
        if (originalValue == undefined) { originalValue = ""; }        
    super.prepare(row, col, prop, td, originalValue, cellProperties);
    this.options = {};
    if (this.cellProperties && this.cellProperties.selectOptions) {
      this.options = Object.assign(this.options, cellProperties.selectOptions);
    }
    cellProperties.selectOptions = Object.assign(
      {},
      cellProperties.selectOptions
    );
  }

    createElements() {        
    this.TEXTAREA = document.createElement("SELECT");

    // Handsontable copy paste plugin calls this.TEXTAREA.select()
    this.TEXTAREA.select = function () { };
    //this.TEXTAREA.setAttribute("multiple", true);
    Handsontable.dom.addClass(this.TEXTAREA, "handsontableInput");
    this.textareaStyle = this.TEXTAREA.style;
    this.textareaStyle.width = 0;
    this.textareaStyle.height = 0;
    this.TEXTAREA_PARENT = document.createElement("DIV");
    Handsontable.dom.addClass(this.TEXTAREA_PARENT, "handsontableInputHolder");
    this.textareaParentStyle = this.TEXTAREA_PARENT.style;
    this.textareaParentStyle.top = 0;
    this.textareaParentStyle.left = 0;
    this.textareaParentStyle.display = "none";
    this.textareaParentStyle.width = "250px";
    this.TEXTAREA_PARENT.appendChild(this.TEXTAREA);
    this.instance.rootElement.appendChild(this.TEXTAREA_PARENT);
  }

    getValue() {
    //TODO
    // console.log("getValue");
    var result = [];
    var options = this.TEXTAREA && this.TEXTAREA.options;
    //console.log("getValueoptions", options);
    var opt;
    for (var i = 0, iLen = options.length; i < iLen; i++) {
      opt = options[i];
      if (opt.selected) {
        result.push(opt.value || opt.text);
      }
    }
    return result.join("|");
  }
    setValue(value) {
    //TODO
    // console.log("setValue", value, typeof value);
    let self = this;
    let array =
      typeof value == "string"
        ? value.split("|").filter(ov => ov !== "").map(m => (typeof m == "string" ? m.trim() : m))
                : value;
    // arr = arr.filter(e => String(e).trim());
    //  console.log("setValuearray", array, self);
    for (var i = 0; i < self.TEXTAREA.length; i++) {
        self.TEXTAREA.options[i].selected = false;
      array.forEach(function (arrayItem) {
        if (self.TEXTAREA.options[i].value === arrayItem) {
          self.TEXTAREA.options[i].selected = true;
        }
      });
    }
  }
    open() {      
    //console.log("open", this);
    this.refreshDimensions();
    this.textareaParentStyle.display = "block";
    //display the list
    this.TEXTAREA.style.display = "none";
    var options = Object.assign({}, this.cellProperties.selectOptions, {
      width: "100%"
    });

    if (options.multiple) {
      this.TEXTAREA.setAttribute("multiple", true);
    } else {
      this.TEXTAREA.removeAttribute("multiple");
    }

    //this.TEXTAREA.innerHTML = "";

    let opt = document.createElement("option");
    opt.setAttribute("value", "");
    this.TEXTAREA.appendChild(opt);

    while (this.TEXTAREA.firstChild) {
      this.TEXTAREA.removeChild(this.TEXTAREA.firstChild);
        }      
    let el = null;
    let originalValue =
      this.originalValue && typeof this.originalValue == "string"
        ? this.originalValue
          .split("|").filter(ov => ov !== "")
          .map(i => (typeof i == "string" ? i.trim() : i))
        : this.originalValue;

    // console.log("#############", this.originalValue, originalValue)
        if (options.data && options.data.length) {
      if (options.multiple) {
        for (let i = 0; i < originalValue.length; i++) {
          el = document.createElement("option");
          el.setAttribute("value", originalValue[i]);
          el.innerHTML = originalValue[i];
          el.setAttribute("selected", true);
          this.TEXTAREA.appendChild(el);
        }
      }

      if (this.prop === "default_myview_name") {
        let myView = this.instance.getDataAtCell(this.row, 11).split("|").filter(mv => mv !== "");
        //  console.log("pinned data at cell", myView)

        el = document.createElement("option");
        el.setAttribute("value", "");
        el.setAttribute("disabled", "disabled");
        el.setAttribute("selected", true);
        el.innerHTML = "";
        this.TEXTAREA.appendChild(el);
        for (let i = 0; i < myView.length; i++) {

          el = document.createElement("option");
          el.setAttribute("value", myView[i]);
          el.innerHTML = myView[i];
          if (originalValue && originalValue.indexOf(myView[i]) > -1) {
            el.setAttribute("selected", true);
          }
          this.TEXTAREA.appendChild(el);
        }

      } else {

        if (!options.multiple) {
          el = document.createElement("option");
          el.setAttribute("value", "");
          el.setAttribute("disabled", "disabled");
          el.setAttribute("selected", true);
          el.innerHTML = "";
          this.TEXTAREA.appendChild(el);
        }
          var regExp = /\(([^)]+)\)/;
          for (let i = 0; i < options.data.length; i++) {
          // if (options.multiple && options.data[i].label == "") continue; // added to remove empty get selected
          el = document.createElement("option");
          el.setAttribute("value", options.data[i].label);
              el.innerHTML = options.data[i].label;  
              if (originalValue != null &&  (originalValue.indexOf(options.data[i].label) > -1 || (this.prop === "primaryTaskCode" && originalValue.indexOf(regExp.exec(options.data[i].label)[1]) > -1))) {
            //el.setAttribute("selected", true);
            if (options.multiple) {
              el.setAttribute("selected", true);
              continue;
            } else {
              el.setAttribute("selected", true);
            }
          }
          this.TEXTAREA.appendChild(el);
        }
      }
    }

    this.choices = new Choices(this.TEXTAREA, {
      silent: true,
      searchEnabled: true,
      searchChoices: true,
      removeItems: true,
      removeItemButton: (this.prop === "account_disabled") ? false : true,
      shouldSort: false,
      shouldSortItems: false,
      resetScrollPosition: true,
      renderSelectedChoices: "auto",
      placeholder: true,
      placeholderValue: "Search...",
      searchPlaceholderValue: "Search...",
      searchResultLimit: 100,
      fuseOptions: {
        // include: 'score',
        location: 0,
        distance: 800,
        threshold: 0.2,
        findAllMatches: false

      },
      choices: []
    });
    this.choices.showDropdown();
  }
  close() {
    //TODO
    this._opened = false;
    this.TEXTAREA.style.display = "none";
    if (this.choices !== undefined) {
      this.choices.destroy();
    }
  }
  focus() {
    //TODO
    this.TEXTAREA.focus();
    if (this.choices !== undefined) {
      this.choices.showDropdown();
    }
  }

  /**
   * Refreshes editor's size and position.
   *
   * @private
   */

  /* refreshDimensions() {
   var width = Handsontable.dom.outerWidth(this.TD);
        // important - group layout reads together for better performance
        var height = Handsontable.dom.outerHeight(this.TD);
        var rootOffset = Handsontable.dom.offset(this.instance.rootElement);
        var tdOffset = Handsontable.dom.offset(this.TD);
        var editorSection = this.checkEditorSection();
        var cssTransformOffset;

        switch (editorSection) {
            case 'top':
                cssTransformOffset = Handsontable.dom.getCssTransform(this.instance.view.wt.wtScrollbars.vertical.clone.wtTable.holder.parentNode);
                break;
            case 'left':
                cssTransformOffset = Handsontable.dom.getCssTransform(this.instance.view.wt.wtScrollbars.horizontal.clone.wtTable.holder.parentNode);
                break;
            case 'corner':
                cssTransformOffset = Handsontable.dom.getCssTransform(this.instance.view.wt.wtScrollbars.corner.clone.wtTable.holder.parentNode);
                break;
        }
        var selectStyle = this.TEXTAREA_PARENT.style;

        if (cssTransformOffset && cssTransformOffset !== -1) {
            selectStyle[cssTransformOffset[0]] = cssTransformOffset[1];
        } else {
            Handsontable.dom.resetCssTransform(this.TEXTAREA);
        }

        selectStyle.height = height  +'px';
        selectStyle.minWidth = width + 'px';
        selectStyle.top = tdOffset.top - rootOffset.top + 'px';
        selectStyle.left = tdOffset.left - rootOffset.left + 'px';
        selectStyle.margin = '0px';
        selectStyle.display = '';
  }
  
 checkEditorSection() {
  console.log("get edited cell");
     if (this.row < this.instance.getSettings().fixedRowsTop) {
            if (this.col < this.instance.getSettings().fixedColumnsLeft) {
                return 'corner';
            } else {
                return 'top';
            }
        } else {
            if (this.col < this.instance.getSettings().fixedColumnsLeft) {
                return 'left';
            }
        }
  }*/
  onBeforeKeyDown() {
    //TODO
    this.TEXTAREA.style.display = "block";
  }
}

export default MultiSelectEditor;
